var exports = {
  "kL": "StickerGridItem.module__container___MXlwaD",
  "Bd": "StickerGridItem.module__stickerWrapper___MXlwaD",
  "HF": "StickerGridItem.module__stickerImage___MXlwaD",
  "Qs": "StickerGridItem.module__content___MXlwaD",
  "wx": "StickerGridItem.module__header___MXlwaD",
  "Zl": "StickerGridItem.module__stickerName___MXlwaD",
  "mr": "StickerGridItem.module__authorInfo___MXlwaD",
  "Du": "StickerGridItem.module__authorAvatar___MXlwaD",
  "fh": "StickerGridItem.module__authorName___MXlwaD",
  "o1": "StickerGridItem.module__actions___MXlwaD",
  "hP": "StickerGridItem.module__actionButton___MXlwaD" + " " + __webpack_require__(180357)["AS"] + " " + __webpack_require__(180357)["ik"],
  "G5": "StickerGridItem.module__deleteButton___MXlwaD",
  "Kk": "StickerGridItem.module__icon___MXlwaD",
};

module.exports = exports;
